angular.module('gym.reports').controller('ReportLogEntriesCtrl', ["$scope", "report", "logEntries", function($scope, report, logEntries) {
  $scope.report = report;
  return $scope.logEntries = logEntries;
}]);
